import { createReducer, on } from '@ngrx/store';
import { loadTeamsFailure, loadTeamsSuccess, selectTeam } from './teams.actions';
import { Team } from '../../services/cebl.api.types';
import { StoreState } from '../index';

export const featureKey = 'teams';

export interface State extends StoreState {
  slug?: string;
  teams?: Team[];
  teamsMap?: Map<string, Team>;
  teamsMatchesMap?: Map<string, Team>;
}

export const initialState: State = {};

export const reducer = createReducer(
  initialState,
  on(loadTeamsSuccess, (state, {data}) => ({
    ...state,
    teams: data.teams,
    teamsMap: data.teamsMap,
    teamsMatchesMap: data.teamsMatchesMap,
    status: {...initialState.status, ready: true},
  })),
  on(loadTeamsFailure, (state, {error}) => ({...state, status: {loading: false, error, ready: true}})),
  on(selectTeam, (state, {slug}) => ({...state, slug: slug})),
);

